'use client'

import { usePathname } from 'next/navigation'

import { stripLocaleFromPath } from '~/i18n/routing'
import { ExpirationDialog } from '../molecules/expiration-dialog'

type Mode = 'booking' | 'extras'

const routesToMode: Array<{ pattern: RegExp; mode: Mode }> = [
	{ pattern: /^\/booking\/[^/]+\/extras$/, mode: 'booking' },
	{ pattern: /^\/booking\/[^/]+\/payment$/, mode: 'booking' },
	{ pattern: /^\/events\/extras\/[^/]+$/, mode: 'extras' },
]

export const BookingExpirationDialogManager = () => {
	const pathname = stripLocaleFromPath(usePathname() ?? '')

	const mode = routesToMode.find(({ pattern }) => pattern.test(pathname))?.mode

	if (mode) return <ExpirationDialog mode={mode} />

	return null
}
